var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"lds-dual-ring"}):_c('div',[_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}}),_vm._v(" "),(_vm.selectedEvent)?_c('EventInfoModal',{attrs:{"modal-id":_vm.getCustomModalId('event', 1),"event":_vm.selectedEvent},on:{"delete":_vm.deleteEvent}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }